import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpResponse,  HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {

  constructor(private injector:Injector, private notificationService: NotificationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = '';
          if (error.error instanceof ErrorEvent) {
            // client-side error
            //errorMessage = Error: ${error.error.message};
            console.log('client-side error');
            console.log(error.error.message);
            errorMessage = 'Connection failed, Please check your internet connection!!';
            //console.log('Connection failed, Please check your internet connection!!');
          } 
          else 
          {
            // server-side error
            console.log('server-side error Status:', error.status);
            if(error.status==0){
              errorMessage = 'Server down, Please contact your system administration!!';
              this.notificationService.error(errorMessage);
            }
            else
            {
              errorMessage = 'server-side error: ' + error.status;
              //console.log('message', error.message);
            }
          }
          this.notificationService.warn(errorMessage);
          return throwError(errorMessage);
        })
      )
  }

}
